import React from "react";
import { Stack } from "@mui/material";

import { HubSideBar } from "../../components";

export const DocuBuilderSideBar = ({
  FormComponent,
  sideBarWidth = "300px",
}) => {
  return (
    <HubSideBar
      position="right"
      maxWidth={sideBarWidth}
      sx={{ padding: "25px 15px" }}
    >
      <Stack width="100%" gap="15px" height="100%" overflow="hidden">
        {FormComponent}
      </Stack>
    </HubSideBar>
  );
};

export default DocuBuilderSideBar;
